
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Procedures } from '@shared/models';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ProceduresService {
    private _apiUrl = environment.apiUrl;
    private _http = inject(HttpClient);
    private _authHeaders = new HttpHeaders({
        Authorization: '',
    });

    public getProcedures(): Observable<Procedures[]> {
        return this._http.get<Procedures[]>(`${this._apiUrl}/api/procedure/list`, {
            headers: this._authHeaders
        }).pipe(map((resp: any) => {
            const filteredListById = [5,3,6,8];
            return resp.data.filter((item:any) => filteredListById.includes(item.id))
        }));
    }


    public getProcedureById(procedureId: number): Observable<Procedures> {
        return this._http.get<Procedures>(`${this._apiUrl}/api/procedure/${procedureId}`, {
            headers: this._authHeaders
        }).pipe(map((resp: any) => resp.data));
    }
}


